"use strict";
import { getAccount } from "@wagmi/core";
import { popupRegistry } from "components/Popups/registry";
import { PopupType } from "components/Popups/types";
import { wagmiConfig } from "components/Web3Provider/wagmiConfig";
import { submitAtomicBatch } from "state/sagas/transactions/atomicBatch";
import { getSigner, watchForInterruption } from "state/sagas/transactions/utils";
import { addTransaction } from "state/transactions/reducer";
import { call, put } from "typed-redux-saga";
export function* handleAtomicSendCalls(params) {
  const { step, info, account, ignoreInterrupt } = params;
  const from = account.address;
  const { batchedTxRequests } = step;
  const chainId = batchedTxRequests[0].chainId;
  const { throwIfInterrupted } = yield* watchForInterruption(ignoreInterrupt);
  const signer = yield* call(getSigner, account.address);
  const batchId = yield* call(() => submitAtomicBatch({ provider: signer.provider, batchedTxRequests, from, chainId }));
  const connectorId = getAccount(wagmiConfig).connector?.id;
  const batchInfo = { connectorId, batchId, chainId };
  yield* put(addTransaction({ from: account.address, info, hash: batchId, chainId, batchInfo }));
  popupRegistry.addPopup({ type: PopupType.Transaction, hash: batchId }, batchId);
  yield* call(throwIfInterrupted);
  return batchId;
}
